import ApiClientFactory from '../../../api/client-factory';
import { SettingsApiLocationService } from './service';

const service = new SettingsApiLocationService(ApiClientFactory());

export function SettingsApiLocationServiceFactory(): typeof service {
  return service;
}
